import React, { useEffect, useState } from 'react';
import { Chart, registerables } from 'chart.js';
import { View, Image, Text } from '@react-pdf/renderer';

Chart.register(...registerables);

const generateRadialQuadrantChart = () => {
  return new Promise((resolve, reject) => {
    if (typeof window !== 'undefined' && window.document) {
      const canvas = window.document.createElement('canvas');
      canvas.width = 800;
      canvas.height = 600;
      const ctx = canvas.getContext('2d');

      if (!ctx) {
        reject(new Error('Could not get canvas context'));
        return;
      }

      const colors = ['#C99212', '#B6111F', '#00577D', '#667F96'];
      const labels = ['Strength', 'Heart', 'Soul', 'Mind'];
      const data = [15, 30, 30, 25];

      ctx.save();
      const centerX = canvas.width / 2;
      const centerY = canvas.height / 2;
      const maxRadius = 250;
      const whiteLineWidth = 10; 

      const maxValue = Math.max(...data);
      const radiusScale = maxRadius / maxValue;
      const angles = [-Math.PI / 2, 0, Math.PI / 2, Math.PI];
      
      ctx.fillStyle = 'white';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      ctx.strokeStyle = 'white';
      ctx.lineWidth = whiteLineWidth;
      
      data.forEach((value, index) => {
        const radius = value * radiusScale;
        const startAngle = angles[index];
        const endAngle = startAngle + (Math.PI / 2);

        ctx.beginPath();
        ctx.moveTo(centerX, centerY);
        ctx.arc(centerX, centerY, radius, startAngle, endAngle);
        ctx.lineTo(centerX, centerY);
        ctx.closePath();
        ctx.fillStyle = colors[index];
        ctx.fill();

        ctx.beginPath();
        ctx.moveTo(centerX, centerY);
        const outerX = centerX + maxRadius * Math.cos(startAngle);
        const outerY = centerY + maxRadius * Math.sin(startAngle);
        ctx.lineTo(outerX, outerY);
        ctx.strokeStyle = 'white';
        ctx.lineWidth = whiteLineWidth;
        ctx.stroke();

        // Add percentage text
        const midAngle = (startAngle + endAngle) / 2;
        const textX = centerX + (radius * 0.7) * Math.cos(midAngle);
        const textY = centerY + (radius * 0.7) * Math.sin(midAngle);

        ctx.fillStyle = 'white';
        ctx.font = 'bold 22px Arial';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(`${value}%`, textX, textY);
      });

      // Add labels
      ctx.fillStyle = 'black';
      ctx.font = 'bold 28px Arial';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';

    ctx.fillText('Mind', centerX - maxRadius - 40, centerY - maxRadius);
    ctx.fillText('Soul', centerX - maxRadius - 40, centerY + maxRadius);
    ctx.fillText('Strength', centerX + maxRadius + 40, centerY - maxRadius);
    ctx.fillText('Heart', centerX + maxRadius + 40, centerY + maxRadius);

      ctx.restore();
      resolve(canvas.toDataURL('image/png'));
    } else {
      reject(new Error('Window or document object not available'));
    }
  });
};

const StarterSecondChart = () => {
  const [chartImage, setChartImage] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    generateRadialQuadrantChart()
      .then(setChartImage)
      .catch(setError);
  }, []);

  if (error) {
    return (
      <View style={{  justifyContent: 'left', alignItems: 'left',  }}>
        <Text>Error generating chart: {error.message}</Text>
      </View>
    );
  }

  return (
    <View style={{  justifyContent: 'left', alignItems: 'left',  marginButtom: "0px" }}>
      {chartImage ? (
        <Image src={chartImage} style={{ width: 350, height: 250, alignSelf: 'left' }} />
      ) : (
        <Text>Loading chart...</Text>
      )}
    </View>
  );
};

export default StarterSecondChart;